import React, { useEffect, useRef } from 'react';
import { useT } from '../i18n/LanguageContext';

export default function ShippingReviewDialog({ title, onClose, children }) {
  const t = useT();
  const panel = useRef(null);
  useEffect(() => {
    const previous = document.activeElement;
    panel.current?.focus();
    const keyboard = event => {
      if (event.key === 'Escape') onClose();
      if (event.key !== 'Tab') return;
      const controls = [...panel.current.querySelectorAll('button:not(:disabled),input:not(:disabled),select:not(:disabled),textarea:not(:disabled),[tabindex="0"]')];
      if (!controls.length) { event.preventDefault(); return; }
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === panel.current)) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    };
    const node = panel.current;
    node.addEventListener('keydown', keyboard);
    return () => { node.removeEventListener('keydown', keyboard); previous?.focus(); };
  }, [onClose]);
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
    <div ref={panel} role="dialog" aria-modal="true" aria-label={t(title)} tabIndex={-1}
      className="w-full max-w-2xl max-h-[90vh] overflow-y-auto rounded-xl bg-white p-5 shadow-xl">
      <div className="flex items-center justify-between gap-3 mb-4">
        <h2 className="text-lg font-semibold">{t(title)}</h2>
        <button type="button" onClick={onClose} className="text-sm text-[#0089ff]">{t('Close')}</button>
      </div>
      {children}
    </div>
  </div>;
}
